import React from 'react';
import { motion } from 'framer-motion';
import { Users, TrendingUp, ShieldCheck, Zap } from 'lucide-react';
export function About() {
  const features = [{
    icon: <Users className="w-6 h-6 text-brand-accent" data-id="element-17" />,
    title: 'Works alongside internal teams',
    desc: "We don't replace your staff; we empower them by taking over operational heavy lifting."
  }, {
    icon: <TrendingUp className="w-6 h-6 text-brand-accent" data-id="element-18" />,
    title: 'Supports scaling',
    desc: 'Rapidly expand your capacity without the overhead of traditional hiring cycles.'
  }, {
    icon: <Zap className="w-6 h-6 text-brand-accent" data-id="element-19" />,
    title: 'Performance-based partnership',
    desc: 'Our success is tied directly to yours. We focus on outcomes, not just activities.'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-brand-accent" data-id="element-20" />,
    title: 'Embedded business support',
    desc: 'Deep integration into your workflows for seamless, high-trust collaboration.'
  }];
  return <section id="about" className="py-24 bg-slate-900/50" data-id="element-21">
      <div className="container mx-auto px-6" data-id="element-22">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-23">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-24">
            <h2 className="text-brand-accent font-bold tracking-widest uppercase text-sm mb-4" data-id="element-25">
              The Deskmayte Advantage
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-26">
              Your Strategic <br data-id="element-27" />
              Operational Extension
            </h3>
            <p className="text-lg text-slate-400 mb-8 leading-relaxed" data-id="element-28">
              Deskmayte is more than a BPO. We are a strategic partner that
              integrates into your company as an operational extension. We
              handle the complexities of scaling so you can focus on the vision.
            </p>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-29">
              {features.map((f, i) => <div key={i} className="p-6 rounded-2xl bg-white/5 border border-white/10 hover:border-brand-accent/30 transition-all group" data-id="element-30">
                  <div className="mb-4 group-hover:scale-110 transition-transform" data-id="element-31">
                    {f.icon}
                  </div>
                  <h4 className="text-white font-bold mb-2" data-id="element-32">{f.title}</h4>
                  <p className="text-sm text-slate-400 leading-relaxed" data-id="element-33">
                    {f.desc}
                  </p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-34">
            <div className="aspect-square rounded-3xl overflow-hidden border border-white/10" data-id="element-35">
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80" alt="Team collaboration" className="w-full h-full object-cover" data-id="element-36" />
            </div>
            <div className="absolute -bottom-6 -left-6 p-8 glass-card rounded-2xl max-w-xs" data-id="element-37">
              <p className="text-brand-accent font-bold text-3xl mb-1" data-id="element-38">100%</p>
              <p className="text-white font-medium" data-id="element-39">
                Integration with your existing tech stack and culture.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}